import React from 'react'
import { View, TouchableOpacity } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text, Icon, IconName } from '@src/components/base'

export interface LabUploadOption {
  label: string
  icon: IconName
  fileSizeLimitMb?: number
  onPress: () => void
}

export const LabUploadOption = ({ label, icon, onPress, fileSizeLimitMb }: LabUploadOption) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <TouchableOpacity style={styles.container} onPress={onPress} accessibilityLabel={label}>
      <View style={styles.content}>
        <Icon name={icon} size={24} />
        <Text type="large">{label}</Text>
      </View>
      {fileSizeLimitMb && (
        <Text type="small" style={styles.fileSizeLimit}>
          max {fileSizeLimitMb} MB
        </Text>
      )}
    </TouchableOpacity>
  )
}

const themedStyles = StyleService.create({
  container: {
    backgroundColor: 'theme.surface.base3',
    paddingVertical: 24,
    borderRadius: 16,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: 'theme.surface.base',
    width: '100%',
    alignItems: 'center',
  },
  content: {
    flexDirection: 'row',
    gap: 10,
  },
  icon: {
    width: 24,
    height: 24,
  },
  fileSizeLimit: {
    marginTop: 2,
    color: 'theme.text.secondary',
  },
})
